export interface General_Interface {
  id:number,
  title:String,
  code:string,
  dsc: string,
  reserve_id?:number,
  userDsc?:string,
  domain?:boolean,
  del:boolean,
  DeletingProccess:boolean
}

export function Empty_General_Interface():General_Interface{
  return{
    id:0,
    title:'',
    code:'',
    dsc: '',
    reserve_id:0,
    domain:false,
    del:false,
    DeletingProccess:false
  }
}
